// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"465f5128","453":"100c6a51"}[chunkId] + ".chunk.js";
};